import React, { useState, useEffect } from 'react';

export interface IDesconto {
    desconto: number | string | null | undefined;
    onClose?: () => void;
}

export const Desconto: React.FC<IDesconto> = (props) => {
  const [elements, setElements] = useState<{
    confetti: any[];
    balloons: any[];
  }>({ confetti: [], balloons: [] });

  // Confete animado
  const Confetti = ({ color, left, top, delay, duration }: any) => (
    <div
      style={{
        position: 'absolute',
        left: `${left}%`,
        top: `${top}%`,
        backgroundColor: color,
        width: '10px',
        height: '10px',
        borderRadius: Math.random() > 0.5 ? '50%' : '2px',
        animation: `fall ${duration}s linear ${delay}s infinite`,
        opacity: 0.8,
        zIndex: 10,
      }}
    />
  );

  // Balão animado
  const Balloon = ({ color, left, delay }: any) => (
    <div
      style={{
        position: 'absolute',
        left: `${left}%`,
        bottom: '-100px',
        animation: `floatUp 8s ease-in ${delay}s infinite`,
        zIndex: 20,
      }}
    >
      <svg width="65" height="85" viewBox="0 0 80 100" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0Z"
          fill={color}
        />
        <path d="M40 80L35 90H45L40 80Z" fill={color} />
        <path d="M40 90C40 95 38 100 35 100" stroke="white" strokeWidth="2" strokeOpacity="0.5" />
      </svg>
    </div>
  );

  useEffect(() => {
    const colors = [
      '#FF3E4D', '#3B82F6', '#10B981', '#FBBF24', 
      '#8B5CF6', '#EC4899', '#06B6D4', '#F97316'
    ];
    // Espalha confetes e balões por toda a área do modal
    const newConfetti = Array.from({ length: 40 }).map((_, i) => ({
      id: i,
      left: Math.random() * 100,
      top: Math.random() * 100,
      color: colors[Math.floor(Math.random() * colors.length)],
      delay: Math.random() * 5,
      duration: 4 + Math.random() * 3,
    }));

    const newBalloons = Array.from({ length: 6 }).map((_, i) => ({
      id: i,
      left: 10 + Math.random() * 80,
      color: colors[Math.floor(Math.random() * colors.length)],
      delay: Math.random() * 8,
    }));

    setElements({ confetti: newConfetti, balloons: newBalloons });
  }, []);

  const displayDesconto = props.desconto ?? 50;

  return (
    <div
      style={{
        position: 'relative',
        width: 900,
        height: 520,
        borderRadius: 24,
        background: 'linear-gradient(135deg, #4f46e5 0%, #9333ea 50%, #db2777 100%)',
        boxShadow: '0 8px 32px rgba(0,0,0,0.25)',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {/* Estilos das Animações */}
      <style>{`
        @keyframes fall {
          0% { transform: translateY(-50px) rotate(0deg); opacity: 1; }
          100% { transform: translateY(500px) rotate(720deg); opacity: 0; }
        }
        @keyframes floatUp {
          0% { transform: translateY(0) rotate(0deg); opacity: 0; }
          10% { opacity: 1; }
          90% { opacity: 1; }
          100% { transform: translateY(-600px) rotate(15deg); opacity: 0; }
        }
        @keyframes popIn {
          0% { transform: scale(0.8) translateY(20px); opacity: 0; }
          100% { transform: scale(1) translateY(0); opacity: 1; }
        }
      `}</style>

      {/* Botão de fechar */}
      <button
        onClick={props.onClose}
        style={{
          position: 'absolute',
          top: 18,
          right: 18,
          zIndex: 50,
          background: 'rgba(0,0,0,0.18)',
          border: 'none',
          borderRadius: '50%',
          width: 36,
          height: 36,
          color: '#fff',
          fontSize: 22,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>

      {/* Confetes e balões */}
      {elements.confetti.map((c) => (
        <Confetti key={`conf-${c.id}`} {...c} />
      ))}
      {elements.balloons.map((b) => (
        <Balloon key={`ball-${b.id}`} {...b} />
      ))}

      {/* Card branco centralizado */}
      <div
        style={{
          position: 'relative',
          zIndex: 30,
          background: 'rgba(255,255,255,0.97)',
          borderRadius: 32,
          padding: '40px 32px 32px 32px',
          boxShadow: '0 4px 24px rgba(0,0,0,0.10)',
          maxWidth: 540,
          width: '100%',
          textAlign: 'center',
          animation: 'popIn 0.6s cubic-bezier(0.16, 1, 0.3, 1) both'
        }}
      >
        <div style={{ fontWeight: 900, fontSize: 40, color: '#222', marginBottom: 8, letterSpacing: 0.5 }}>
          PARABÉNS! <span role="img" aria-label="party">🎉</span>
        </div>
        <div
          style={{
            fontWeight: 900,
            fontSize: 80,
            background: 'linear-gradient(90deg, #6366f1 0%, #a21caf 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            marginBottom: 8,
            letterSpacing: -2,
            lineHeight: 1.1,
          }}
        >
          {displayDesconto}% OFF
        </div>
        <div style={{ fontSize: 30, color: '#444', fontWeight: 600 }}>
          Ganhou um desconto<br />super exclusivo!
        </div>
      </div>
    </div>
  );
};



